import gsap from "@lib/gsap";
import createAccordion from "@lib/accordion";
import { ref, watch } from "@vue/reactivity";

export default function (element, dataset) {
  const currentTab = ref(1);
  const items = element.querySelectorAll('[data-element="item"]');
  const images = element.querySelectorAll('[data-element="image"]');
  const accordion = createAccordion(items);

  if (window.innerWidth > 991) {
    moveImages(element);
  }

  items.forEach((e, index) => {
    e.addEventListener("click", () => {
      currentTab.value = index;
    });
  });

  watch(currentTab, (newValue, oldValue) => {
    let itemsToClose = Array.from(items).filter((_, i) => i !== newValue);
    let imagesToHide = Array.from(images).filter((_, i) => i !== newValue);

    itemsToClose.forEach((item) => accordion.close(item));
    accordion.open(items[newValue]);

    gsap.to(imagesToHide, { opacity: 0 });
    gsap.to(images[newValue], { opacity: 1 });
  });

  currentTab.value = 0;
}

function moveImages(element) {
  const images = element.querySelectorAll('[data-element="image"]');
  const holder = element.querySelector('[data-element="image-holder"]');

  images.forEach((e) => {
    holder.append(e);
  });
}
